import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import { releases } from '../../../data/capabilities';

/** Tarihi "29 Ağustos 2026" biçimine çevirir. */
const formatReleaseDate = (isoDate) =>
  new Date(isoDate).toLocaleDateString('tr-TR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

const WhatsNewSection = () => {
  const latest = releases?.[0];
  // Liste büyüdükçe bölüm sayfayı ele geçiriyordu; ilk sekiz görünür, gerisi
  // istenince açılır.
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? releases : releases.slice(0, 8);

  return (
    <section id="yenilikler" className="py-20 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-white/10 text-white px-4 py-2 rounded-full mb-6">
            <Icon name="Rocket" size={16} />
            <span className="font-inter font-accent-medium text-sm">Sürüm Notları</span>
          </div>

          <h2 className="font-poppins font-heading-bold text-3xl md:text-4xl lg:text-5xl mb-6">
            Son Eklenen{' '}
            <span className="text-primary">Özellikler</span>
          </h2>

          <p className="font-open-sans font-body-normal text-lg text-gray-300 max-w-3xl mx-auto">
            Ürün her hafta büyüyor. Aşağıdaki liste yol haritası değil, teslim edilmiş işlerin
            kaydı — hepsi bugün panelde açık.
            {latest && (
              <> Son güncelleme: <span className="text-white font-semibold">{formatReleaseDate(latest.date)}</span>.</>
            )}
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Dikey çizgi — mobilde solda, masaüstünde ortada değil: okuma sırası tek sütun kalsın */}
          <div className="absolute left-6 top-0 bottom-0 w-px bg-white/15 hidden sm:block" aria-hidden="true" />

          <div className="space-y-4">
            {visible.map((release) => (
              <div
                key={`${release.date}-${release.title}`}
                className="relative sm:pl-20 p-6 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors duration-300"
              >
                {/* Timeline noktası */}
                <div className={`hidden sm:flex absolute left-0 top-6 w-12 h-12 rounded-xl ${release.color} items-center justify-center shadow-lg`}>
                  <Icon name={release.icon} size={22} color="white" />
                </div>

                <div className="flex flex-wrap items-center gap-3 mb-2">
                  <div className={`sm:hidden w-9 h-9 rounded-lg ${release.color} flex items-center justify-center`}>
                    <Icon name={release.icon} size={18} color="white" />
                  </div>
                  <h3 className="font-poppins font-heading-semibold text-lg">
                    {release.title}
                  </h3>
                  <span className="px-3 py-1 rounded-full bg-primary/20 text-primary text-xs font-inter font-accent-medium">
                    {release.tag}
                  </span>
                  <time
                    dateTime={release.date}
                    className="font-open-sans font-body-normal text-xs text-gray-400 ml-auto"
                  >
                    {formatReleaseDate(release.date)}
                  </time>
                </div>

                <p className="font-open-sans font-body-normal text-sm text-gray-300 leading-relaxed">
                  {release.summary}
                </p>
                {release.href && (
                  <Link
                    to={release.href}
                    className="mt-3 inline-flex items-center gap-1 font-inter font-accent-semibold text-sm text-primary hover:text-white transition-colors"
                  >
                    Ayrıntılar
                    <Icon name="ArrowRight" size={14} />
                  </Link>
                )}
              </div>
            ))}
          </div>

          {releases.length > visible.length && (
            <div className="mt-6 text-center">
              <button
                type="button"
                onClick={() => setExpanded(true)}
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-white/20 font-inter font-accent-medium text-sm hover:bg-white/10"
              >
                Önceki {releases.length - visible.length} güncellemeyi göster
                <Icon name="ChevronDown" size={16} />
              </button>
            </div>
          )}
        </div>

        {/* Yolda olanlar — vaat değil, durum bildirimi */}
        <div className="mt-12 p-6 rounded-2xl border border-dashed border-white/20">
          <div className="flex items-center space-x-2 mb-4">
            <Icon name="Wrench" size={18} className="text-gray-400" />
            <h3 className="font-poppins font-heading-semibold text-lg">Üzerinde çalıştıklarımız</h3>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {[
              { title: 'Yazarkasa (ÖKC) entegrasyonu', note: 'Cihaz ve doküman tedariki sürüyor' },
              { title: 'e-Arşiv / e-Fatura gönderimi', note: 'Belge katmanı hazır, entegratör bekleniyor' },
              { title: 'Kurye mobil uygulaması', note: 'Ekranlar yazıldı, mağaza yayını hazırlanıyor' },
              { title: 'Masadan kartla ödeme', note: 'QR Menü Pro paketine eklenecek' },
              { title: 'Pazaryeri entegrasyonu', note: 'Platform anlaşmaları tamamlanınca açılacak' }
            ].map((item) => (
              <div key={item.title} className="p-4 rounded-xl bg-white/5">
                <p className="font-inter font-accent-semibold text-sm mb-1">{item.title}</p>
                <p className="font-open-sans font-body-normal text-xs text-gray-400">{item.note}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatsNewSection;
